import styled from 'styled-components';
import { _flex } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Search } from 'assets/images/search_icon.svg';
import List from 'components/List';

interface IconSearchProps {
  isLoading: boolean;
}

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ListContainer = styled(List)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &.has-filters {
    margin-top: 8px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0;
  }
`;

export const EmptyContainer = styled.div`
  flex: 1;
`;

export const SearchButton = styled.div`
  cursor: pointer;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
`;

export const IconSearch = styled(Search)<IconSearchProps>`
  width: 24px;
  height: 24px;
  margin: 0 auto;
  color: ${({ isLoading, theme }) => (!isLoading ? ColorPalette.HEX.OuterSpace : ColorPalette.HEX.Platinum)};
`;

export const ButtonsContainer = styled.div`
  ${_flex({ align: 'center' })};
  margin: 16px 16px 0 16px;
  width: calc(100% - 32px);
  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
    width: auto;
  }
`;

export const TabContainer = styled.div`
  ${_flex({ align: 'center' })};
  width: calc(100% - 48px);
  @media ${({ theme }) => theme.device.desktop} {
    width: auto;
  }
`;

export const FilterTagsContainer = styled.div`
  ${_flex({ align: 'center' })};
  display: grid;
  padding: 0;
`;
